export const getTax = (taxId) => ({ taxes: { taxList } }) =>
taxList.find(({ id }) => id === +taxId);
